<script setup>
import { useRouter, useRoute } from 'vue-router';
import { onMounted } from 'vue';

const router = useRouter();
const route = useRoute();

onMounted(() => {
  if (route.name === 'disparo_home') {
    router.replace({
      name: 'disparo_dividas',
      params: { accountId: route.params.accountId },
    });
  }
});
</script>

<template>
  <router-view />
</template>
